import * as React from 'react';
import { BrManageMenuButton } from '@bloomreach/react-sdk';
import { Header, SiteNav } from '@grandvisionhq/layout';

const CmsHeader = ({ headerLogo , headerLogoMobile , headerLogoLink , headerMenuItems , navMenuItems , appointmentMenuItems , headerMenuModel , navMenuModel , appointmentMenuModel , pageRoutes , availableLocales , countrySwitcherOptions , myAccountButton , preview , renderCartButton , renderWishlistMenuItem , onSubmitSearch , staticsUrl , algoliaHeaderConfig , renderSiteNav =true , hasOnlyLogo =false , siteName , ordersUrl ,  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, preview && headerMenuModel && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(BrManageMenuButton, {
        menu: headerMenuModel
    })), /*#__PURE__*/ React.createElement(Header, {
        logo: headerLogo,
        logoMobile: headerLogoMobile,
        logoLink: headerLogoLink,
        pageRoutes: pageRoutes,
        menuItems: headerMenuItems,
        myAccountButton: myAccountButton,
        renderCartButton: renderCartButton,
        renderWishlistMenuItem: renderWishlistMenuItem,
        availableLocales: availableLocales,
        staticsUrl: staticsUrl,
        algoliaHeaderConfig: algoliaHeaderConfig,
        onSubmit: onSubmitSearch,
        preview: preview,
        countrySwitcherOptions: countrySwitcherOptions,
        renderSiteNav: renderSiteNav,
        hasOnlyLogo: hasOnlyLogo,
        siteName: siteName,
        ordersUrl: ordersUrl
    }, renderSiteNav && /*#__PURE__*/ React.createElement(React.Fragment, null, preview && navMenuModel && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(BrManageMenuButton, {
        menu: navMenuModel
    })), /*#__PURE__*/ React.createElement(SiteNav, {
        menuItems: navMenuItems,
        appointmentItems: appointmentMenuItems,
        routes: {
            cart: pageRoutes.cart,
            stores: pageRoutes.stores
        },
        countrySwitcherOptions: countrySwitcherOptions,
        renderCartButton: renderCartButton,
        renderWishlistMenuItem: renderWishlistMenuItem,
        ordersUrl: ordersUrl
    }), preview && appointmentMenuModel && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement(BrManageMenuButton, {
        menu: appointmentMenuModel
    })))))
;

export { CmsHeader, CmsHeader as default };
//# sourceMappingURL=Header.js.map
